import { Alert, Box, Col, Collapse, Row } from '@ksyos/design-system';
import { lazy, Suspense, useState } from 'react';
import { getSelectedLanguage } from '@frontend/translate';

const EmploymentTaxesDetailsModal = lazy(() =>
    import('../employmentTaxesDetails/EmploymentTaxesDetailsModal').then((module) => ({
        default: module.EmploymentTaxesDetailsModal,
    }))
);

export function EmploymentTaxesDetailsAlert() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [collapsedTextIsOpen, setCollapsedTextIsOpen] = useState<boolean>(false);

    const thirdPartyPaymentLawLink =
        'https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/personeel_en_loon/uitbetaalde_bedragen_aan_derden/';

    const translate = getSelectedLanguage();

    return (
        <>
            <Alert
                appearance="warning"
                hasIcon={true}
                noMargin={true}
            >
                <Row
                    align="flex-start"
                    style={{ marginBottom: '0.5rem' }}
                    wrap={'wrap'}
                >
                    <Col span={8}>
                        <Box>
                            <Alert.Text
                                as="p"
                                fontWeight="bold"
                                mb={2}
                            >
                                {translate.employmentTaxesDetails.alert.title}
                            </Alert.Text>
                            <Alert.Text
                                as="p"
                                size="md"
                            >
                                {translate.employmentTaxesDetails.alert.descriptionTextFirstPart}{' '}
                                <Alert.Link
                                    fontWeight="normal"
                                    href={thirdPartyPaymentLawLink}
                                    openInNewTab={true}
                                    variant="externalLink"
                                >
                                    {translate.employmentTaxesDetails.alert.descriptionLinkText}
                                </Alert.Link>{' '}
                                {translate.employmentTaxesDetails.alert.descriptionTextSecondPart}
                            </Alert.Text>
                        </Box>
                    </Col>
                    <Col span={4}>
                        <Box
                            alignItems="flex-start"
                            display="flex"
                            flexWrap="wrap"
                            gap={4}
                            justifyContent="flex-end"
                        >
                            <Alert.Button
                                onClick={() => {
                                    setIsModalOpen(true);
                                }}
                            >
                                {translate.employmentTaxesDetails.alert.completeDetailsButton}
                            </Alert.Button>
                        </Box>
                    </Col>
                </Row>

                <Row>
                    <Alert.Link
                        fontWeight="normal"
                        iconLeft={collapsedTextIsOpen ? 'caret-up' : 'caret-down'}
                        my={2}
                        onClick={() => setCollapsedTextIsOpen(!collapsedTextIsOpen)}
                        size="xs"
                        variant="button"
                    >
                        {collapsedTextIsOpen ? translate.common.lessInformation : translate.common.moreInformation}
                    </Alert.Link>
                    <Collapse isOpen={collapsedTextIsOpen}>
                        <Alert.Text
                            as="p"
                            size="sm"
                        >
                            {translate.employmentTaxesDetails.alert.collapsedTextFirstPart}
                            <br />
                            {translate.employmentTaxesDetails.alert.collapsedTextSecondPart}
                            <Alert.Link
                                href="mailto:privacy@ksyos.nl"
                                openInNewTab={true}
                                variant="externalLink"
                            >
                                privacy@ksyos.nl.
                            </Alert.Link>
                        </Alert.Text>
                    </Collapse>
                </Row>
            </Alert>

            <Suspense>
                <EmploymentTaxesDetailsModal
                    handleChangeIsOpen={(isOpened) => setIsModalOpen(isOpened)}
                    isOpen={isModalOpen}
                />
            </Suspense>
        </>
    );
}
